// extracted by mini-css-extract-plugin
export default {"container":"timeout-widget_App_container"};